import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PreviewResponse } from '../../api/client.service';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'san-widerruf-bestaetigung-partner',
  templateUrl: './widerruf-bestaetigung-partner.component.html',
  styleUrls: ['./widerruf-bestaetigung-partner.component.scss'],
  standalone: false,
})
export class WiderrufBestaetigungPartnerComponent implements OnInit {
  @Input() teilnahmeerklaerung: boolean;
  @Input() state: PreviewResponse;
  @Output() downloadTneClicked = new EventEmitter();
  @Output() abmeldenClicked = new EventEmitter();

  loadingIcon = faSpinner;

  constructor() {}

  ngOnInit(): void {}
}
